import { X } from 'lucide-react';

// Reusable Components
export const Button = ({ className = '', ...props }) => <button className={`transition-all duration-200 ${className}`} {...props} />;

const CloseButton = ({ onClose }) => (
  <Button
    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10 p-2 hover:bg-gray-100 rounded-full group"
    onClick={onClose}
    aria-label="Close"
  >
    <X className="w-5 h-5 transform group-hover:rotate-90 transition-transform" />
  </Button>
);

const Modal = ({ isOpen, onClose, containerClass, children }) =>
  isOpen && (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[120] flex justify-center items-center p-4 animate-fadeIn overflow-y-auto scrollbar-gutter-stable"
      onClick={onClose}
    >
      <div className="min-h-screen py-6 flex flex-col justify-center sm:py-12">
        <div
          className={containerClass || 'relative bg-white rounded-xl shadow-2xl w-full max-w-md animate-slideIn mx-auto'}
          onClick={(e) => e.stopPropagation()}
        >
          <CloseButton onClose={onClose} />
          <div
            className="p-8 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400"
            style={{
              scrollbarGutter: 'stable',
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );

export default Modal;
